module.exports = __webpack_public_path__ + "media/assets/images/blog/CloudApplications-images-small-c4a4dea5a359798bedac7081f011d3a8.jpg";